import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { LandLineListInterface } from '../../../../landlines/models/land-line-list.interface';
import { SaveLandlineMission } from '../../../store/actions/landline-mission.actions';

@Component({
  selector: 'app-identify-line',
  templateUrl: './identify-line.component.html',
  styleUrls: ['./identify-line.component.css'],
  standalone: false
})
export class IdentifyLineComponent implements OnInit {

  @Input()
  line: LineInterface|null;

  @Input()
  landLine: LandLineListInterface|null;

  @Input()
  name: string;

  @Input()
  procedureCode: string;

  newName: string;
  error: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
    this.error = false;
    this.newName = this.name;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    this.error = false;
    if (this.newName !== '' && this.formSubmitted === false) {
      this.formSubmitted = true;
      if (this.landLine) {
        this.store.dispatch(
            new SaveLandlineMission(
                {
                  step: 1,
                  newName : this.newName,
                  oldName: this.name,
                  landline: this.landLine.phoneNumber
                },
                this.procedureCode
            )
        );
      } else {
        this.store.dispatch(
            new SaveMission(
                {
                  step: 1,
                  newName : this.newName,
                  oldName: this.name,
                  phoneNumber: this.line.phoneNumber
                },
                this.procedureCode
            )
        );
      }
    } else {
      this.error = true;
    }
  }
}
